import { useRef, useState } from 'react';
import { isEqual } from 'lodash';
import useDeepCompareEffect from 'use-deep-compare-effect';

type ValueType = unknown[] | Record<string | number, unknown>;

export const useValueChangedCount = (value: ValueType): number => {
	const [valueChangedCount, setValueChangedCount] = useState(0);
	const prevValue = useRef(value);

	useDeepCompareEffect(() => {
		if (!isEqual(prevValue.current, value)) {
			prevValue.current = value;
			setValueChangedCount((count) => count + 1);
		}
	}, [value]);

	return valueChangedCount;
};
